// extracted by mini-css-extract-plugin
export default {"four":"SecFour_four__vGvkj"};